import React, { Component } from "react";
import { connect } from "react-redux";
import { map } from "lodash";
import * as matchesActions from "../../../_actions/matchesActions";
import UserWidgetContainer from "../UserWidgetContainer";
import Section from "../../UI/Section";
import PageSubTitle from "../../UI/PageSubTitle";
import InfiniteScroll from "react-infinite-scroller";
import getExpressedInterest from "../../../_selectors/matchesSelectors/getExpressedInterest";
import getMatchesLastResult from "../../../_selectors/matchesSelectors/getMatchesLastResult";
import { updateObject } from "../../../_utils";
import matchesConstants from "../../../_constants/matchesConstants";
import HoverWidget from "../../UI/HoverWidget";
class ExpressedInterest extends Component {
  componentDidMount() {
    const { updateHeader, updateBreadcrumb, getExpressedInterest } = this.props;
    updateHeader({
      title: "Expressed Interest Members",
      description: "Members that you expressed interest in"
    });
    updateBreadcrumb([
      { label: "Home", link: "/" },
      { label: "Matches", link: "/matches" },
      { label: "Expressed Interest Members", link: "/search" }
    ]);
    getExpressedInterest();
  }
  componentWillUnmount() {
    const { clearMembers, clearExpressedInterest } = this.props;
    clearMembers();
    clearExpressedInterest();
  }
  loadMoreItems = page => {
    const { lastResult, loadMore, results } = this.props;
    loadMore({ lastResult });
  };
  render() {
    const { results, lastResult } = this.props;
    return (
      <Section white={results.length === 0}>
        <InfiniteScroll
          pageStart={0}
          loadMore={this.loadMoreItems}
          hasMore={lastResult !== null}
          initialLoad={false}
          loader={
            <div
              className="loader"
              style={{
                height: "50px",
                background: "#4d4d4d",
                textAlign: "center",
                lineHeight: "50px",
                color: "#fff",
                fontSize: "1.5em",
                marginTop: "1em"
              }}
            >
              Please Wait
            </div>
          }
        >
          <div className="row">
            {results.length === 0 ? (
              <div className="dev-table">
                <HoverWidget
                  title="No Members"
                  text="List of all the members you expressed interest in"
                  link="/search"
                  linkText="Start Exploring Members"
                  success
                />
              </div>
            ) : (
              map(results, result => (
                <div key={result.id} className="col-md-4">
                  <UserWidgetContainer user={result.profileId} />
                </div>
              ))
            )}
          </div>
        </InfiniteScroll>
      </Section>
    );
  }
}
const mapStateToProps = (state, ownProps) => ({
  results: getExpressedInterest(state),
  lastResult: getMatchesLastResult(state)
});

const mapDispatchToProps = dispatch => ({
  getExpressedInterest: () =>
    dispatch(matchesActions.getExpressedInterestMembers()),
  clearMembers: () => dispatch(matchesActions.clearMatchedMembers()),
  clearExpressedInterest: () =>
    dispatch(matchesActions.clearExpressedInterestMembers()),
  loadMore: payload =>
    dispatch(
      matchesActions.loadMoreSearchResults(
        updateObject(payload, {
          type: matchesConstants.GET_EXPRESSED_INTEREST_MEMBERS
        })
      )
    )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExpressedInterest);



// WEBPACK FOOTER //
// ./src/_components/Matches/ExpressedInterest/index.js